// Module
var code = "Partagez ce lien<br> ci-dessous à vos amis";
// Exports
module.exports = code;